{
  "increasedQuantity": "Số lượng tăng",
  "decreasedQuantity": "Số lượng giảm",
  "rewardQuantity": "Số lượng thưởng",
  "jbpSystemOrderNumber": "Mã lệnh hệ thống JBP",
  "walletTransactionNumber": "Mã giao dịch ví",
  "transactionId": "Mã giao dịch (TxID)",
  "exchangeRate": "Tỷ giá",
  "exchangeRateFromUsdt": "1 USDT ≈ {{amount}} {{token}}",
  "transferInAmount": "Số tiền nạp vào",
  "convertedAmount": "Số lượng quy đổi",
  "paymentQuantity": "Số lượng thanh toán",
  "receivedQuantity": "Số lượng nhận"
}
